export default __webpack_public_path__ + "static/media/bakanlik_yazisi_2.85a406ed.jpg";